var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"sold-out-tag"},[_vm._v(_vm._s(_vm.parent.$t('sold_off')))])}
var staticRenderFns = []

export { render, staticRenderFns }